var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.40332 5.74609C7.69629 5.57812 8.05957 5.55078 8.34863 5.76172L13.9736 9.19922C14.251 9.37109 14.4229 9.67188 14.4229 10C14.4229 10.3281 14.251 10.6289 13.9736 10.8008L8.34863 14.2383C8.05957 14.4141 7.69629 14.4219 7.40332 14.2539C7.10645 14.0898 6.92285 13.7773 6.92285 13.4375V6.52734C6.92285 6.22266 7.10645 5.91016 7.40332 5.74609ZM20.0479 10C20.0479 15.5234 15.5713 20 10.0479 20C4.52441 20 0.0478516 15.5234 0.0478516 10C0.0478516 4.47656 4.52441 0 10.0479 0C15.5713 0 20.0479 4.47656 20.0479 10ZM10.0479 1.875C5.55957 1.875 1.92285 5.51172 1.92285 10C1.92285 14.4883 5.55957 18.125 10.0479 18.125C14.5361 18.125 18.1729 14.4883 18.1729 10C18.1729 5.51172 14.5361 1.875 10.0479 1.875Z",
    fill: "#707A83"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.c0737385a177e82c45f8c02d4b8cedf0.svg";
export { ForwardRef as ReactComponent };